var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6981 0.666664C13.2437 0.666664 13.7668 0.884514 14.1487 1.26952L16.7328 3.8536C17.1176 4.23833 17.3337 4.76014 17.3337 5.30423C17.3337 5.84832 17.1176 6.37013 16.7328 6.75486L7.29825 16.1865C6.71618 16.8579 5.89108 17.2704 4.94583 17.3353H0.666992V16.5019L0.669699 12.9894C0.740691 12.1107 1.14921 11.2936 1.77241 10.7445L11.2465 1.27052C11.6307 0.884022 12.1531 0.666664 12.6981 0.666664ZM4.88698 15.6707C5.33216 15.6392 5.74656 15.432 6.07932 15.0513L12.3809 8.74977L9.25225 5.621L2.91374 11.958C2.57612 12.2566 2.36725 12.6744 2.33366 13.0565V15.6691L4.88698 15.6707ZM10.4309 4.44263L13.5594 7.57126L15.5543 5.57635C15.6265 5.50418 15.667 5.40629 15.667 5.30423C15.667 5.20217 15.6265 5.10428 15.5543 5.03211L12.9679 2.44571C12.8966 2.37379 12.7994 2.33333 12.6981 2.33333C12.5968 2.33333 12.4997 2.37379 12.4283 2.44571L10.4309 4.44263Z",
    fill: "#9999A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.fc82504146521c26276d16fc52535ff1.svg";
export { ForwardRef as ReactComponent };